import compose from 'ramda/src/compose';
import not from 'ramda/src/not';

export const isMarketingMaterial = item => item.productFamily === 'Marketing Materials';
export const isSample = item => /^s\d+/i.test( item.sku );
export const isNotMarketingMaterial = compose( not, isMarketingMaterial );
export const isNotSample = compose( not, isSample );
